<template lang="pug">
Card.selections-card.house-info-form
  template(#content)
    .house-info-form-body
      CountrySelector.country
      NumberOfBedrooms.bedrooms
      AgeOfHome.age
      HouseType.type(:houseTypes="filteredHouseTypes")
      HouseTypology.typology(v-if="!!houseTypeSelected")
</template>
<script lang="ts">
import { useSelections } from "@/store/selections";
import { defineComponent } from "vue";
import { storeToRefs } from "pinia";
import AgeOfHome from "./AgeOfHome.vue";
import HouseType from "./HouseType.vue";
import HouseTypology from "./HouseTypology.vue";
import NumberOfBedrooms from "./NumberOfBedrooms.vue";
import CountrySelector from "./CountrySelector.vue";
import Card from "primevue/card";

export default defineComponent({
  name: "HouseInfo",
  components: {
    Card,
    CountrySelector,
    AgeOfHome,
    NumberOfBedrooms,
    HouseType,
    HouseTypology,
  },
  setup() {
    const { houseTypeSelected, filteredHouseTypes } = storeToRefs(
      useSelections()
    );
    return {
      houseTypeSelected,
      filteredHouseTypes,
    };
  },
});
</script>
<style scoped lang="scss">
.house-info-form {
  &-body {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: baseline;
    width: 100%;
  }
  .selections-card {
    padding: 0;
    border: none;
    box-shadow: none;
    min-width: 45%;
    :deep(.p-card-header) {
      padding: 0;
    }
    :deep(.p-card-content) {
      padding-left: 0;
      padding-right: 0;
    }
  }
  .age,
  .typology {
    width: 100%;
    flex-grow: 1;
  }
  .age {
    :deep(.slider-wrapper) {
      padding-top: 1.25rem;
    }
    :deep(.p-card-content) {
      padding: 1rem 0;
    }
  }
  .typology {
    :deep(.typologies-wrapper .typology-card) {
      height: min-content;
      width: max-content;
      max-width: calc(12.5rem + 2px);
    }
  }
  .storeys {
    :deep(.p-card-content),
    :deep(.form-control-buttons) {
      padding-top: 0;
      margin-top: 0;
    }
    :deep(.form-control-buttons) {
      justify-content: flex-start;
    }
  }
  @media screen and (max-width: 540px) {
    .type {
      :deep(.dropdown-wrapper .p-dropdown) {
        min-width: auto;
      }
    }
  }
}
</style>
